import React from 'react';
import { Card, CardContent, CardHeader } from '../ui/card';

export interface InsightsLoadingSkeletonProps {
  ariaLabel?: string;
}

// Skeleton partilhado de carregamento dos Insights, extraido do padrao da Lite
// para que Lite e Pro mostrem a mesma experiencia de loading.
const InsightsLoadingSkeleton: React.FC<InsightsLoadingSkeletonProps> = ({ ariaLabel }) => (
  <div className="space-y-4 md:space-y-6" aria-busy="true" aria-label={ariaLabel}>
    <div className="space-y-2">
      <div className="h-7 w-56 animate-pulse rounded bg-stone-200" />
      <div className="h-3 w-72 animate-pulse rounded bg-stone-200" />
    </div>
    <div className="h-10 w-full animate-pulse rounded-md bg-stone-200" />
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-[minmax(0,1fr)_340px]">
      <Card className="border-stone-200 bg-white">
        <CardHeader>
          <div className="h-5 w-40 animate-pulse rounded bg-stone-200" />
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-4">
            <div className="h-10 w-16 animate-pulse rounded bg-stone-200" />
            <div className="h-3 flex-1 animate-pulse rounded bg-stone-100" />
          </div>
        </CardContent>
      </Card>
      <Card className="border-stone-200 bg-white">
        <CardHeader>
          <div className="h-5 w-32 animate-pulse rounded bg-stone-200" />
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="h-3 w-full animate-pulse rounded bg-stone-100" />
          <div className="h-9 w-full animate-pulse rounded bg-stone-200" />
        </CardContent>
      </Card>
    </div>
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {[0, 1, 2, 3, 4, 5].map((index) => (
        <Card key={index} className="border-stone-200 bg-white">
          <CardHeader className="pb-3">
            <div className="h-5 w-28 animate-pulse rounded bg-stone-200" />
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="h-2 w-full animate-pulse rounded-full bg-stone-100" />
            <div className="h-12 w-full animate-pulse rounded bg-stone-100" />
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);

export default InsightsLoadingSkeleton;
